import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/pages/HomePage';
import LoginPage from './components/pages/LoginPage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import UsersPage from './components/pages/UsersPage';
import { UserProvider } from './contexts/userContext';
import { ColumnsProvider } from './contexts/columnsContext';
import { CardProvider } from './contexts/cardContext';
import ColumnsPage from './components/pages/ColumnsPage';
import PCP from './components/pages/PCP';
import DashboardPage from './components/pages/DashboardPage';
import LandingPage from './components/pages/LandingPage';
import SignUp from './components/pages/SignUp';
import ClientePage from './components/pages/ClientePage';
import OrdensProducao from './components/pages/OrdensProducao';
import MeusTestesPage from './components/pages/MeusTestesPage';
import Participantes from './components/pages/Participantes';
import TVSlider from './components/TVSlider';
import ProjetosPage from './components/pages/ProjetosPage';
import PortalPage from './components/pages/PortalPage';
import { GlobalProvider } from './contexts/GlobalContext';
import PrivateRoute from "./components/PrivateRoute"; // 🔹 Importando corretamente o componente
import SuperAdminRoute from './components/auth/SuperAdminRoute';
import CompanyAdminRoute from './components/auth/CompanyAdminRoute';
import FaktoryPage from './components/pages/FaktoryPage';
import TerminalProducao from './components/pages/TerminalProducao';
import MarketingPage from './components/pages/MarketingPage';
import BazzeBrokerPage from './components/pages/BazzeBrokerPage';
import PainelMKT from './components/pages/PainelMKT';
import ExpoRevestirPage from './components/pages/ExpoRevestirPage';
import WhatsappZapiSettings from './components/WhatsappZapi/WhatsappZapiSettings';
import { WhatsappZapiProvider } from './contexts/whatsappZapiContext';
import WhatsappMetaSettings from './components/WhatsappMeta/WhatsappMetaSettings';
import { WHATSAPP_META_UI_ENABLED } from './config/whatsappMetaFeature';

import DashboardProducao from './components/pages/DashboardProducao';
import ImportarPVATPage from './components/pages/ImportarPVATPage';
import PreSalesIntelligencePage from './components/pages/PreSalesIntelligencePage';
import HomeNewPage from './components/pages/HomeNewPage';
import HomeNewRouteGuard from './components/pages/HomeNewPage/HomeNewRouteGuard';





function App() {
  return (
    <Router> {/* 🔹 Agora o Router vem antes do GlobalProvider */}
      <GlobalProvider> {/* 🔹 Agora o useNavigate funciona corretamente */}
        <UserProvider>
          <ColumnsProvider>
            <WhatsappZapiProvider>
              <CardProvider>
                <Routes>
                  <Route path="/" element={<LandingPage />} />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/signup" element={<SignUp />} />
                  <Route path="/tracking/:cardId" element={<ClientePage />} />
                  <Route path="/producao" element={<OrdensProducao />} />
                  <Route path="/testes" element={<MeusTestesPage />} />
                  <Route path="/estoque" element={<FaktoryPage />} />
                  <Route path="/terminal" element={<TerminalProducao />} />
                  <Route path="/expo-revestir-2026" element={<ExpoRevestirPage />} />


                  <Route element={<HomeNewRouteGuard />}>
                    <Route path="/home-new" element={<HomeNewPage />} />
                  </Route>

                  <Route element={<PrivateRoute />}>
                    <Route path="/home" element={<HomePage />} />
                    <Route element={<SuperAdminRoute />}>
                      <Route path="/users" element={<UsersPage />} />
                      <Route path="/process" element={<ColumnsPage />} />
                    </Route>
                    <Route element={<CompanyAdminRoute />}>
                      <Route path="/configuracoes/inteligencia-pre-venda" element={<PreSalesIntelligencePage />} />
                    </Route>
                    <Route path="/whatsapp-zapi" element={<WhatsappZapiSettings />} />
                    {WHATSAPP_META_UI_ENABLED && <Route path="/whatsapp-meta" element={<WhatsappMetaSettings />} />}
                    <Route path="/pcp" element={<PCP />} />
                    <Route path="/dashboard" element={<DashboardPage />} />
                    <Route path="/participantes" element={<Participantes />} />
                    <Route path="/slider" element={<TVSlider />} />
                    <Route path="/projetos" element={<ProjetosPage />} />
                    <Route path="/portal" element={<PortalPage />} />
                    <Route path="/marketing" element={<MarketingPage />} />
                    <Route path="/painel-mkt" element={<PainelMKT />} />
                    <Route path="/bazze-broker" element={<BazzeBrokerPage />} />
                    <Route path="/tvproducao" element={<DashboardProducao />} />
                    <Route path="/importar-pvat" element={<ImportarPVATPage />} />
                  </Route>
                </Routes>
              </CardProvider>
            </WhatsappZapiProvider>
          </ColumnsProvider>
        </UserProvider>
      </GlobalProvider>
    </Router> 
  );
}

export default App;
